import Query from '../Query';

export default function SecurityCheck(query: Query) {
  query.addHeader('X-Security-Check', query.securityCheck);
}
